module.exports = __webpack_public_path__ + "img/icons_browser.1925929.png";